import { MdLocationPin, MdOutlineCake, MdOutlineEmail, MdOutlineLocalPhone } from "react-icons/md";
import userImg from "../../assets/userImg.png";
import React from "react";
import CustomChip from "../../components/common/CustomChip";

const LeadNameHover = ({ lead, status }) => {
  console.log('lead hover data',lead);
  
  // Fallback Dummy Data
  const fallbackLead = {
    name: "Random Lead",
    id: Math.floor(Math.random() * 10000),
    email: "random.email@gmail.com",
    status: "active",
    mobile: "9999999999",
    dob: "01 Jan 2000",
    address: "Random Street, City",
    city: "Random City",
    state: "Random State",
    image: userImg,
  };

  const leadData = lead || fallbackLead; // Use provided data, else fallback

  return (
    <div className="absolute left-0 mt-2 w-80 p-4 bg-white shadow-lg border border-gray-300 rounded-md z-50">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src={leadData.image || userImg}
            alt={leadData.name}
            className="w-10 h-10 rounded-full"
          />
          <div>
            <h3 className="text-md font-bold text-[#213650]">{leadData.name}</h3>
            <p className="text-sm text-gray-500">#{leadData.lead_display_id}</p>
          </div>
        </div>
        <CustomChip
          label={status}
          variant={status === "Assigned" ? "pending" : status === "New" ? "success" : "error"}
        />
      </div>

      {/* Two-Column Layout */}
      <div className="mt-3 grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-gray-700">
        <div className="flex items-center">
          <MdOutlineEmail className="text-lg text-gray-500" />
          <strong className="ml-2 text-[#2F4E74]">Email:</strong>
        </div>
        <div className="break-all">{leadData.email}</div>

        <div className="flex items-center">
          <MdOutlineLocalPhone className="text-lg text-gray-500" />
          <strong className="ml-2">Mobile:</strong>
        </div>
        <div>{leadData?.contact_number}</div>

        <div className="flex items-center">
          <MdOutlineCake className="text-lg text-gray-500" />
          <strong className="ml-2">DOB:</strong>
        </div>
        <div>{leadData.dob ? new Date(leadData.dob).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "N/A"}</div>


        <div className="flex items-center">
          <MdLocationPin className="text-lg text-gray-500" />
          <strong className="ml-2">Address:</strong>
        </div>
        <div>{leadData.address}</div>

        <div className="flex items-center">
          <MdLocationPin className="text-lg text-gray-500" />
          <strong className="ml-2">City:</strong>
        </div>
        <div>{leadData.city_id?.title}</div>

        <div className="flex items-center">
          <MdLocationPin className="text-lg text-gray-500" />
          <strong className="ml-2">State:</strong>
        </div>
        <div>{leadData?.city_id?.state_id?.title}</div>
      </div>
    </div>
  );
};

export default LeadNameHover;
